import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Fires a fire-and-forget /api/track on every route change so the admin dashboard
 * can show daily visitors + top pages. Skips admin routes so team activity doesn't
 * distort visitor counts.
 */
const detectDevice = () => {
  const ua = (navigator.userAgent || "").toLowerCase();
  if (/ipad|tablet|(android(?!.*mobile))/.test(ua)) return "tablet";
  if (/mobi|iphone|ipod|android|blackberry|windows phone/.test(ua)) return "mobile";
  return "desktop";
};

export default function PageTracker() {
  const { pathname, search } = useLocation();
  const lastSent = useRef("");

  useEffect(() => {
    // Don't track admin views — they'd inflate the numbers we want to show the admin.
    if (pathname.startsWith("/admin")) return;
    const key = `${pathname}${search || ""}`;
    if (key === lastSent.current) return;
    lastSent.current = key;
    // Fire-and-forget: never block navigation, never surface errors to the user.
    api.post("/track", {
      path: key.slice(0, 300),
      referrer: (document.referrer || "").slice(0, 300),
      device: detectDevice(),
    }).catch(() => {});
  }, [pathname, search]);

  return null;
}
